<template>
  <header>
    <a class="top cursor-pointer" href="/">
    </a>
    <div class="bottom">
      <div class="wrapper">
        <h1>Chuyên order hàng nguyên liệu hãng</h1>
        <div class="filter">
          <img
            src="@/assets/icons/search-status.png"
            alt=""
            height="25px"
            @click="handleFilterProducts()"
          />
          <input
            v-model="filter.name"
            type="text"
            name="keyword"
            placeholder="Nhập tên hoặc mã sản phẩm cần tìm"
            @keyup.enter="handleFilterProducts()"
          />

          <AppSecondaryButton
            caption="Tìm kiếm"
            @onClick="handleFilterProducts()"
          />

          <!-- <AppSecondaryButton
            caption="Bộ lọc sản phẩm"
            :icon="require(`@/assets/icons/candle-2.png`)"
            @onClick="openModal()"
          /> -->
        </div>
        <div class="scroller" v-if="categories.length">
          <div class="position-relative">
            <div class="categories" ref="categories">
              <div
                class="category"
                v-for="m in menu"
                :key="m.key"
                @click.self="selectCategory($event, m)"
              >
                <span @click.stop="$event.target.parentElement.click()">{{
                  m.name
                }}</span>
                <div v-if="m.children" class="carpet-down">
                  <img
                    @click.stop="show($event)"
                    src="@/assets/icons/down-svgrepo-com.svg"
                    alt=""
                    width="12"
                    height="12"
                  />
                </div>
                <div class="sub" ref="subs">
                  <ul v-if="m.children">
                    <li
                      v-for="(c, index) in m.children"
                      :key="'child-' + index"
                    >
                      <AppAccordion
                        :configs="c"
                        @selected="selectSubMenu($event, c)"
                      >
                        <!-- <template v-if="c.children">
                          <AppAccordion
                            v-for="(sc, index) in c.children"
                            :key="sc.key + '-' + index"
                            :configs="sc"
                            @selected="selectSubMenu($event, sc)"
                          ></AppAccordion>
                        </template> -->
                      </AppAccordion>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <dialog ref="dialog">
        <div class="dialog-header">
          <h4>Lọc Sản Phẩm</h4>
          <img
            src="@/assets/icons/times-svgrepo-com.svg"
            alt=""
            @click="closeModal()"
          />
        </div>
        <div class="dialog-body">
          <div class="accordion" id="accordionFilter">
            <div class="accordion-item" v-if="groups.length">
              <h2 class="accordion-header" id="headingGroup">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseGroup"
                  aria-expanded="true"
                  aria-controls="collapseGroup"
                >
                  Nhóm
                </button>
              </h2>
              <div
                id="collapseGroup"
                class="accordion-collapse collapse show"
                aria-labelledby="headingGroup"
                data-bs-parent="#accordionFilter"
              >
                <div class="accordion-body">
                  <AppCheckBox
                    ref="checkboxes"
                    v-for="group in groups"
                    :key="group.id"
                    :keyi="group.id"
                    group="group_id"
                    :value="group.name"
                    @onChecked="checked($event)"
                  />
                </div>
              </div>
            </div>
            <div class="accordion-item" v-if="genders.length">
              <h2 class="accordion-header" id="headingGender">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseGender"
                  aria-expanded="false"
                  aria-controls="collapseGender"
                >
                  Giới tính
                </button>
              </h2>
              <div
                id="collapseGender"
                class="accordion-collapse collapse"
                aria-labelledby="headingGender"
                data-bs-parent="#accordionFilter"
              >
                <div class="accordion-body">
                  <AppCheckBox
                    ref="checkboxes"
                    v-for="gender in genders"
                    :key="gender.id"
                    group="gender_id"
                    :keyi="gender.id"
                    :value="gender.name"
                    @onChecked="checked($event)"
                  />
                </div>
              </div>
            </div>
            <div class="accordion-item" v-if="states.length">
              <h2 class="accordion-header" id="headingState">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseState"
                  aria-expanded="false"
                  aria-controls="collapseState"
                >
                  Trạng thái
                </button>
              </h2>
              <div
                id="collapseState"
                class="accordion-collapse collapse"
                aria-labelledby="headingState"
                data-bs-parent="#accordionFilter"
              >
                <div class="accordion-body">
                  <AppCheckBox
                    ref="checkboxes"
                    v-for="state in states"
                    :key="state.id"
                    group="state_id"
                    :keyi="state.id"
                    :value="state.name"
                    @onChecked="checked($event)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-footer d-flex justify-content-center my-4">
          <div class="actions">
            <AppPrimaryButton
              caption="Áp Dụng"
              size="xl"
              @onClick="applyFilter()"
            />
          </div>
          <span @click="clearAll()"
            >Xóa Lọc <img src="@/assets/icons/times-svgrepo-com (1).svg" alt=""
          /></span>
        </div>
      </dialog>
    </div>
  </header>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('publicStoreModule');

import AppCheckBox from '@/views/front/components/CheckBox.vue';
import AppPrimaryButton from '@/views/front/components/PrimaryButton.vue';
import AppSecondaryButton from '@/views/front/components/SecondaryButton.vue';
import AppAccordion from '@/views/front/components/Accordion.vue';
export default {
  name: 'Header',
  components: {
    AppCheckBox,
    AppPrimaryButton,
    AppSecondaryButton,
    AppAccordion,
  },
  data() {
    return {
      filter: {
        name: null,
        category_id: null,
        brand_id: null,
      },
      checkedItems: [],
      scrollPosition: 0,
      PIXELS: 208, //categoty offsetwith is 200px + 8px of margin right
      SHOW_RIGHT_SCROLLING: true,
      DISABLE_LEFT_SCROLLING: false,
    };
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
    this.getMenu();
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    window.scrollTo(0, 0);
    setTimeout(() => {
      const menus = this.$refs.categories;
      if (menus) {
        menus.childNodes[0].classList.add('active');
        menus.addEventListener('scroll', this.handleScroll);
      }
    }, 2000);
    this.getCategories();
    // this.getBrands();
    // this.getGroups();
    // this.getStates();
  },
  methods: {
    ...mapActions([
      'getMenu',
      'getCategory',
      'getCategories',
      'getBrands',
      'getGroups',
      'getStates',
      'getProducts',
    ]),

    getIconUrl(category) {
      return category.icon
        ? `${category.base_url}${category.icon.url}`
        : '@/assets/icons/category_default.png';
    },

    selectCategory(e, m) {
      const categories = this.$refs.categories;
      categories.childNodes.forEach((el) => {
        if (el == e.target) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });

      if (m.type == 1 && m.query) {
        this.filter = m.param;
        this.handleFilterProducts(); 
      } else if (m.type == 0) {
        this.$router
          .push({ name: 'front.menu.detail', params: { key: m.key } })
          .catch(() => {});
        this.getCategory(m.query);
      }

      this.hideDropdown();
    },

    selectSubMenu(e, sm) {
      this.hideDropdown();

      // const el = e.target;
      // const category = el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
      // const categories = this.$refs.categories;
      // categories.childNodes.forEach((el) => {
      //   if (el == category) {
      //     el.classList.add('active');
      //   } else {
      //     el.classList.remove('active');
      //   }
      // });

      this.filter = sm.param;
      if (sm.link) {
        // window.location.href = sm.link;
        this.$router.push(sm.link);

        let params = this.$route.params;

        if (!params) {
          params = {};
        }

        if (!params.page) {
          params.page = 1;
        }

        const routeName = this.$route.name;
        switch (routeName) {
          case 'front.home.brand':
            params.filter = {
              brand_id: params.id,
            };
            break;
          case 'front.home.state':
            params.filter = {
              state_id: params.id,
            };
            break;
          case 'front.home.category':
            params.filter = {
              category_id: params.id,
            };
            break;
          case 'front.home.gender':
            params.filter = {
              gender_id: params.id,
            };
            break;
          case 'front.home.group':
            params.filter = {
              group_id: params.id,
            };
            break;
        }

        this.getProducts(params);
      } else {
        this.handleFilterProducts();
      }
    },

    handleFilterProducts() {
      const params = { filter: this.filter, page: 1 };
      this.getProducts(params);
      this.$router.push({ name: 'front.home' }).catch(() => {});
    },

    openModal() {
      const modal = this.$refs.dialog;
      modal.showModal();
    },

    closeModal() {
      const modal = this.$refs.dialog;
      modal.classList.add('hide');

      let coolFunction = () => {
        modal.classList.remove('hide');
        modal.close();
        modal.removeEventListener('webkitAnimationEnd', coolFunction);
      };

      modal.addEventListener('webkitAnimationEnd', coolFunction);
    },

    checked(e) {
      const group = Object.keys(e)[0];
      const member = e[group];
      if (member.checked === false) {
        const index = this.checkedItems[group].findIndex(
          (item) => item.key === member.key
        );
        if (index !== -1) this.checkedItems[group].splice(index, 1);
        return;
      }

      const hasGroup = this.checkedItems[group];
      if (hasGroup) this.checkedItems[group].push(member);
      else this.checkedItems[group] = [member];
    },

    clearAll() {
      Object.keys(this.checkedItems).forEach(
        (group) => (this.checkedItems[group] = [])
      );
      const checkboxes = this.$refs.checkboxes;
      checkboxes.forEach((checkbox) => checkbox.unCheck());

      // alert(JSON.stringify(this.checkedItems))
    },

    applyFilter() {
      const groups = Object.keys(this.checkedItems);

      const filters = [];
      groups.forEach((group) => {
        filters.push({
          [group]: this.checkedItems[group].map((x) => x.id),
        });
      });

      // alert(JSON.stringify(filters));
      const params = { filter: filters, page: 1 };
      this.getProducts(params);
      this.closeModal();
      this.$router
        .push({ name: 'front.home.filter', params: { params: params } })
        .catch(() => {});
    },

    show(e) {
      const el = e.target;
      const parent = el.parentElement;
      const subMenu = parent.nextSibling;
      if (subMenu.classList.contains('active')) {
        subMenu.classList.remove('active');
        return;
      }
      this.hideDropdown();
      const category = el.parentElement.parentElement;
      const rectCategory = el.parentElement.parentElement.getBoundingClientRect();
      subMenu.style.left = rectCategory.left + 'px';
      subMenu.style.top = rectCategory.top - 50 + 'px';
      subMenu.classList.add('active');
      
      const categories = this.$refs.categories;
      categories.childNodes.forEach((el) => {
        if (el == category) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });
    },

    hideDropdown() {
      if (!this.$refs.categories) return;
      const categories = this.$refs.categories.childNodes;

      categories.forEach((item) => {
        const sub = item.querySelector('.sub');
        sub.classList.remove('active');
      });
    },

    foo(el) {
      const grandGrandParent = el.parentElement.parentElement.parentElement;
      grandGrandParent.querySelector('span').innerText = el.innerText;

      const grandParent = el.parentElement.parentElement;
      grandParent.classList.remove('active');
    },

    handleScroll() {
      this.hideDropdown();
      if (!this.$refs.subs) return;
    },    

    goToHome() {
      this.$router.push('/home');
      const menus = this.$refs.categories;
      menus.childNodes.forEach((el) => {
        el.classList.remove('active');
      });
      menus.childNodes[0].classList.add('active');
    },
  },
  computed: {
    ...mapState([
      'menu',
      'categories',
      'brands',
      'groups',
      'genders',
      'states',
    ]),
  },
};
</script>
<style scoped lang="scss">
header {
  .cursor-pointer {
    cursor: pointer;
  }
  .top {
    box-sizing: border-box;
    max-width: 1440px;
    height: 114px;
    background-color: #fff;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url(/static/img/logo.01ffde12.png);
    background-size: 400px;
    background-position: center;
    background-repeat: no-repeat;
    .brand {
      span {
        cursor: pointer;
        font-size: 48px;
        color: #000;
        font-weight: bold;
        font-family: 'Dela Gothic One', cursive;
      }
      > img {
        height: 400px;
        cursor: pointer;
        // width:100%;
        // height:100%;
        // object-fit:cover;
      }
    }
    .menu {
      span {
        font-size: 16px;
        font-weight: bolder;
        font-family: 'Dela Gothic One', cursive;
        color: #000;
      }
    }
  }
  .bottom {
    background-color: #000;
    min-height: 300px;
    .wrapper {
      max-width: 1440px;
      margin: 0 auto;
      padding: 49px 0 39px 0;
      h1 {
        // width: 289px;
        color: #fff;
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 35px;
        text-transform: capitalize;
      }
      .filter {
        display: flex;
        position: relative;
        > img {
          cursor: pointer;
          position: absolute;
          left: 38px;
          top: 50%;
          transform: translate(-50%, -14px);
        }
        input {
          width: 380px;
          height: 46px;
          border-radius: 10px;
          background-color: #303030;
          padding-left: 88px;
          color: #fff;
          outline: none;
          border: none;
          margin-right: 10px;
          &::placeholder {
            color: #c1c0c0;
          }
        }
      }
      .scroller {
        margin-top: 40px;
        display: flex;
        align-items: center;        
        .categories {
          display: flex;
          max-width: 1525px;
          overflow-x: scroll;
          position: relative;
          &::-webkit-scrollbar {
            display: none !important;
          }
          .category {
            min-width: 130px;
            cursor: pointer;
            margin-right: 8px;
            padding: 5px 10px 5px 10px;
            border-radius: 23px;
            background-color: #8f8f8f1a;
            display: flex;
            align-items: center;
            color: #fff;
            position: relative;
            white-space: nowrap;
            text-overflow: ellipsis;
            > span {
              font-size: 16px;
            }
            &.active {
              background-color: #303030;
            }
            button {
              padding: 0;
              background-color: rgb(138, 138, 138);
              border-radius: 20px;
              width: 36px;
              height: 36px;
              border-radius: 50%;
              outline: none;
              border: none;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 20px;

              img {
                height: 34px;
                width: 34px;
                object-fit: cover;
                border-radius: 50%;
              }
            }
            &:last-child {
              margin-right: 0;
            }
            .carpet-down {
              width: 20px;
              position: absolute;
              top: 50%;
              right: 0;
              transform: translate(0%, -50%);
            }
            .sub {
              position: fixed;
              transform: translateY(92px);
              z-index: 10000;
              background-color: #fff;
              display: none;
              border-radius: 8px;
              > ul li {
                display: none;
              }
              &.active {
                display: block;
                > ul li {
                  display: block;
                }
              }
              ul {
                border-radius: 8px;
                width: 130px;
                background-color: #fff;
                color: #000;
                padding-left: 0px;
                overflow: hidden;
                li {
                  list-style: none;
                  position: relative;
                  &:hover {
                    background-color: #8f8f8f1a;
                    color: #000;
                  }
                  .accordion-button {
                    padding: 4px 8px 4px 8px;
                    &:hover {
                      color: #000 !important;
                    }
                    &::after {
                      background-size: 16px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  dialog {
    width: 400px;
    padding: 0 !important;
    border: none;
    &.hide {
      animation: hide 0.5s ease normal !important;
    }
    &[open] {
      animation: show 0.5s ease normal;
    }
    &:not([open]) {
      display: none !important;
    }
    &::backdrop {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.2);
      animation: none;
    }
    .dialog-header {
      height: 46px;
      background-color: #2c2c2c;
      position: relative;
      h4 {
        color: #fff;
        text-align: center;
        font-size: 16px;
        margin-bottom: 0;
        line-height: 46px;
      }
      img {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
      }
    }
    .dialog-body {
      .accordion-item {
        border: none;
        &:first-of-type .accordion-button {
          height: 53px;
          border-top-left-radius: unset;
          border-top-right-radius: unset;
        }
      }
      .accordion-button:not(.collapsed) {
        color: unset !important;
        background-color: unset !important;
      }
      .accordion-button:focus {
        border-color: unset !important;
        box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
      }
      .accordion-button.collapsed:focus {
        box-shadow: inset 0 -1px 0 rgb(255 255 255 / 13%) !important;
      }
      .accordion-button:not(.collapsed)::after {
        filter: grayscale(1);
      }
    }
    .dialog-footer {
      display: flex;
      flex-direction: column;
      .actions {
        margin: 0 auto;
        margin-bottom: 18px;
      }
      span {
        align-self: flex-end;
        display: inline-block;
        margin-right: 14px;
        cursor: pointer;
        border-bottom: 1px solid #fff;
        &:hover {
          border-bottom: 1px solid #000;
        }
        img {
          transform: translateY(-2px);
        }
      }
    }
  }
}

@keyframes show {
  from {
    opacity: 0;
    transform: translateX(-200px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes hide {
  from {
    opacity: 1;
    transform: translateX(0px);
  }
  to {
    opacity: 0;
    transform: translateX(400px);
  }
}

@media screen and (max-width: 1660px) and (min-width: 1280px) {
  .top,
  .bottom {
    padding: 0 80px;
    .categories {
      width: 1450px;
      flex-wrap: nowrap;
      overflow: scroll;
      ::-webkit-scrollbar {
        display: none !important;
      }
      .category {
        white-space: nowrap;
      }
    }
  }
}

@media screen and (max-width: 1279px) and (min-width: 769px) {
  .top,
  .bottom {
    padding: 26px 60px 0px 60px;
    .scroller {
      position: relative;
      .categories {
        width: 624px;
        flex-wrap: nowrap;
        overflow: hidden;
        &::-webkit-scrollbar {
          display: none !important;
        }
        .category {
          white-space: nowrap;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) and (min-width: 481px) {
  .top,
  .bottom {
    padding: 0 25px;
  }
  .scroller {
    position: relative;
    .categories {
      width: 416px;
      flex-wrap: nowrap;
      overflow: scroll;
      &::-webkit-scrollbar {
        display: none !important;
      }
      .category {
        white-space: nowrap;
      }
    }
  }
}

@media screen and (max-width: 480px) and (min-width: 0) {
  .top,
  .bottom {
    padding: 0 15px;
  }
  .top {
    // padding-top: 20px;
    align-items: baseline !important;

    .brand span {
      font-size: 40px !important;
    }
    .brand > img {
      // height: 140px !important;
    }
  }
  .bottom {
    height: 384px !important;
    .wrapper {
      h1 {
        font-size: 26px !important;
      }
      .filter {
        flex-direction: column;
        input {
          width: 100% !important;
          margin-bottom: 20px;
        }
        > img {
          top: 14% !important;
        }
        button {
          justify-content: center;
        }
      }
      .scroller {
        flex-direction: column;
        position: relative;
        .categories {
          width: 342px;
          flex-wrap: nowrap;
          overflow: scroll;
          &::-webkit-scrollbar {
            display: none !important;
          }
          .category {
            white-space: nowrap;
            // &:not(.sub) {
            //   justify-content: center;
            // }
          }
        }
      }
    }
  }
}
</style>
